<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
========================================================================================== -->


<template>
  <div
      id="app"
      :class="vueAppClasses"
  >
    <router-view @setAppClasses="setAppClasses" />
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'

  export default {
    data () {
      return {
        vueAppClasses: [],
      }
    },
    watch: {
      '$store.state.theme' (val) {
        this.toggleClassInBody(val)
      },
      '$vs.rtl' (val) {
        document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
      }
    },
    methods: {
      toggleClassInBody (className) {
        if (className == 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
          document.body.classList.add('theme-dark')
        }
        else if (className == 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          document.body.classList.add('theme-semi-dark')
        }
        else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        }
      },
      setAppClasses (classesStr) {
        this.vueAppClasses.push(classesStr)
      },
      handleWindowResize () {
        this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

        // Set --vh property
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
      },
      handleScroll () {
        this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
      }
    },
    mounted () {
      global.vm = this
      this.toggleClassInBody(themeConfig.theme)
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`)

      this.$store.dispatch('inspectToken')
      /*
      if (!this.$store.getters.notifications.length) this.$store.dispatch('notificationFetch')
      setInterval(() => {
        this.$store.dispatch('notificationFetch')
      }, 181000)

       */
    },
    async created () {

      let dir = this.$vs.rtl ? "rtl" : "ltr"
      document.documentElement.setAttribute("dir", dir)

      window.addEventListener('resize', this.handleWindowResize)
      window.addEventListener('scroll', this.handleScroll)

    },
    destroyed () {
      window.removeEventListener('resize', this.handleWindowResize)
      window.removeEventListener('scroll', this.handleScroll)
    },
  }

</script>

<style lang="scss">
  .showOverflow {
    overflow: visible;
  }
  .link {
    text-decoration: underline;
    cursor: pointer;
  }
  .pointer {
    cursor: pointer;
  }

  .text-pallet1 {
    color: #FF8B87;
  }
  .text-pallet2 {
    color: #6EBEFF;
  }
  .text-pallet3 {
    color: #F8FF54;
  }
  .text-pallet4 {
    color: #AEB344;
  }
  .email-head {
    position: fixed !important;
    right: 20px;
    top: 200px
  }
  .sms-head {
    position: fixed !important;
    right: 20px;
    top: 290px
  }


  // table css
  #data-list-list-view {
    .vs-con-table {
      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 60%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        // padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
          td {
            padding: 20px;
            &:first-child {
              border-top-left-radius: 0.5rem;
              border-bottom-left-radius: 0.5rem;
            }
            &:last-child {
              border-top-right-radius: 0.5rem;
              border-bottom-right-radius: 0.5rem;
            }
          }
          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check {
          padding: 0 15px !important;
        }
        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }

  // v-slect fixes
  .vs__search {
    line-height: 1.8 !important;
  }
</style>
